import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { GetParameterByTypeScreen, saveParameterByTypeScreen } from "./index";

// Api's
import { parameterApi } from "../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getParameterByTypeScreenSaga(action: GetParameterByTypeScreen) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			parameterApi.getParametersByType,
			action.payload.request,
		);

		if (response.data.result) {
			yield put(saveParameterByTypeScreen(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveParameterByTypeScreen(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
